<template>
    <b-link
        id="btn-target-check-in"
        href="#"
        :disabled="!isAllowedToDoCheckin"
        @click="$emit('checkin')"
        class="btn-check-in"
    >
        <span :id="disableCheckinAction">
            <p class="mb-0 text-center">
                <i class="fa fa-calendar-check-o fa-lg"></i>
            </p>
            <p class="mb-0 mt-xl-1 text-center">
                <small>{{ $t('profile.targetsTable.checkIn') }}</small>
            </p>
            <b-tooltip :target="disableCheckinAction" v-if="!isAllowedToDoCheckin">
                {{ viewCheckinTooltipMessage }}
            </b-tooltip>
        </span>
    </b-link>
</template>

<script>
export default {
    name: 'CheckinButton',
    props: {
        isAllowedToDoCheckin: {
            type: Boolean,
            required: true,
        },
        target: {
            type: Object,
            required: true,
        },
    },
    computed: {
        disableCheckinAction() {
            return 'disable-check-in-action' + this.target.id
        },
        viewCheckinTooltipMessage() {
            return (
                this.$t('profile.targetsTable.userWithoutPermissionCheckin', {
                    stageTitle: this.target.owner.stages.current.title,
                }) + this.viewStageCriteriaMessage
            )
        },
        viewStageCriteriaMessage() {
            const firstEntryCriteria = 0
            if (!this.hasEntryCriteria) {
                return ''
            }
            const criterionIdentifier =
                this.target.owner.stages.current.entryCriteria[firstEntryCriteria].criterion.identifier
            return this.$t(`stages.eventHasCriteriaMessages.${criterionIdentifier}`)
        },
        hasEntryCriteria() {
            return Object.keys(this.target.owner.stages.current.entryCriteria).length
        },
    },
}
</script>
<style lang="scss" scoped>
#btn-target-check-in.disabled {
    color: #6e6e6e;
    cursor: not-allowed;
    text-decoration: none;
}
</style>
